import { AssertIsIntException } from './assert-is-int.exception';
import { isInt } from '@pct-ts/typeguard';

export function assertIsInt(value: unknown, message: string): asserts value is number {
  if (!isInt(value)) {
    throw new AssertIsIntException(`Not a int: ${message}`);
  }
}
